(function (app, ng) {

    app.controller("investmentAccountNotesController", investmentAccountNotesController);

    function investmentAccountNotesController(_, $q, $mdDialog, investmentAccountApi, caseModalService) {
        var $ctrl = this;

        const close = () => {
            $mdDialog.cancel();
        }

        const addNote = (content, accountId, user) => {
            const note = {
                Content: content,
                CreatedById: user.Id,
                CreatedBy: user,
                CreatedOn: new Date()
            }
            $ctrl.notes.push(note);

            investmentAccountApi.addNote(accountId, note).then(response => {
                note.NoteId = response.NoteId;
            });
        };

        const deleteNote = (noteId, accountId, $event) => {
            caseModalService.confirmNoteDeletion($event).then(() => {
                investmentAccountApi.removeNote(accountId, noteId);

                const noteIndex = $ctrl.notes.findIndex(note => note.NoteId === noteId);

                $ctrl.notes.splice(noteIndex, 1);
            });
        }

        ng.extend($ctrl,
            {
                close: close,
                addNote: addNote,
                deleteNote: deleteNote
            });
    }

}) (window.app, window.angular); //jshint: ignore:line